import { put, takeLatest, all, select } from "redux-saga/effects";
import * as Actions from "../../actions/billing/paymentHistoryAction";
import { getPaymentHistoryCall } from "../../../api/billing/index";
import { setAlertState } from "../../../util/util";

export function* getPaymentHistory({ value }) {
  try {
    yield put(Actions.setLoader(true));
    let contractAccount = yield select((state) => state.BILLING.contractAccount);
    let regionId = yield select((state) => state.ACCOUNT.regionId);
    let request = {
      contractAccount,
      regionId,
    };
    const response = yield getPaymentHistoryCall(request);
    yield put(Actions.makePaymentHistoryCall(false));
    response.data.data = response.data.data.filter((x) => !!x);
    // .filter(x => {
    //   return x.transactionNumber !== "";
    // });
    if (response.data.data.length > 0) {
      response.data.data = response.data.data.map((item, index) => {
        item.accordianId = index;
        return item;
      });
      yield put(Actions.getPaymentHistorySuccess(response));
      setAlertState(false);
      yield put(Actions.setTransactionList(response.data.data));
      yield put(Actions.setActualTransactionList(response.data.data));
      yield put(Actions.setLoader(false));
    } else {
      yield put(Actions.setLoader(false));
    }
    yield put(Actions.setLoader(false));
  } catch (error) {
    yield put(Actions.setLoader(false));
    yield put(Actions.makePaymentHistoryCall(true));
    yield put(Actions.getPaymentHistoryFailure(error));
  }
}

export default function* paymentHistoryWatcher() {
  yield all([takeLatest(Actions.LOAD_DATA_PAYMENT, getPaymentHistory)]);
}
